/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Team_Studio_ThreeInputs */

const en_platform_team_studio_three = /** @type {(inputs: Platform_Team_Studio_ThreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nobody can be booked twice`)
};

const pl_platform_team_studio_three = /** @type {(inputs: Platform_Team_Studio_ThreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nikogo nie da się zarezerwować dwa razy`)
};

/**
* | output |
* | --- |
* | "Nobody can be booked twice" |
*
* @param {Platform_Team_Studio_ThreeInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_team_studio_three = /** @type {((inputs?: Platform_Team_Studio_ThreeInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Team_Studio_ThreeInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_team_studio_three(inputs)
	return en_platform_team_studio_three(inputs)
});